import { EChartsOption, LineSeriesOption } from "echarts";
import { SignalTransform } from ".";
import { generateNumbers } from "@/utils/math";
export type PlayStatus = "play" | "pause" | "stop";
export const getDefaultSeriesData = () => {
  const res = {
    // 实际横摆速度
    UIRx_ACUYawRate: [],
    // 前轮角度
    UIRx_AxleStAng_FA: [],
    // 后轮角度
    UIRx_AxleStAng_RA: [],
    // 前轮转向比
    UIRx_FrontGearRto: [],
    // 原始横摆速度
    UIRx_OrgYawRate: [],
    // 后轮转向比
    UIRx_RearGearRto: [],
    // 方向盘角度
    UIRx_SBW_HWAAng: [],
    // 车速
    UIRx_VehSpd: [],
  } as DomianControl.AWSSeriesData;
  return res;
};

export const optionseries1 = () => [
  {
    id: "UIRx_AxleStAng_FA",
    name: "前轮角度",
    color: "#ffb400",
  },
];
export const optionseries2 = () => [
  {
    id: "UIRx_ACUYawRate",
    name: "实际横摆特性",
    color: "#ff5126",
  },
  {
    id: "UIRx_OrgYawRate",
    name: "原始横摆特性",
    color: "#9B30FF",
  },
];
export const optionseries3 = () => [
  {
    id: "UIRx_AxleStAng_RA",
    name: "后轮角度",
    color: "#3498db",
  },
  {
    id: "UIRx_AWSFrontAngAdd",
    name: "前轮叠加角度",
    color: "#eb00b4",
  },
];
export const decreasingSequence = generateNumbers(15);
export const getDefaultSeriesProp = () =>
  ({
    type: "line",
    showSymbol: false,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      width: 2,
    },
    clip: true,
    data: [],
  } as LineSeriesOption);
export const getChartsDefaultOptions = (index: number) => {
  let seriesList =
    [optionseries1(), optionseries2(), optionseries3()][index] ||
    optionseries1();
  const xAxisDate = generateNumbers(15).reverse();
  const max = [50, 30, 8][index];
  const min = [-50, -30, -8][index];

  seriesList = seriesList?.map((item: any) => ({
    ...getDefaultSeriesProp(),
    ...item,
  }));
  const lineColor = "rgba(199, 237, 250,0.2)";
  const interval = (index: number, value: string) => {
    return Number(value) % 5 === 0;
  };
  return {
    backgroundColor: "#032f2b",
    animation: false,
    //   legend: {
    //     show: true,
    //     // x: "4%",
    //     top: "20px",
    //     data: ["123"],
    //     // type: "scroll",
    //     textStyle: {
    //       color: "#cccccc",
    //       fontWeight: 700,
    //       fontSize: 12,
    //     },
    //     formatter: function (name) {
    //       return name;
    //     },
    //   },
    legend: {
      show: true,
      // type: 'scroll',
      // orient: 'vertical',
      // right: 20,
      // top: "10%",
      // bottom: 20,
    },
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#283b56",
        },
      },
    },
    grid: {
      top: 30,
      left: 50,
      right: 50,
      bottom: 30,
    },
    xAxis: {
      name: "sec",
      data: xAxisDate,
      nameTextStyle: {
        color: "#fff",
      },
      // nameGap: -30,
      // minorTick: {
      //   show: true,
      // },
      // minorSplitLine: {
      //   show: true,
      //   lineStyle: {
      //     color: lineColor,
      //   },
      // },
      axisPointer: {
        snap: true,
        lineStyle: {
          color: "#8e96a1",
          width: 2,
        },
        label: {
          show: false,
          // formatter: function (params) {
          //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
          // },
          backgroundColor: "#3fafa5",
        },
        handle: {
          show: true,
          color: "#3fafa5",
          size: 30,
          margin: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowBlur: 0,
        },
      },
      splitLine: {
        show: true,
        interval: (index: number, value: string) => {
          return (
            (Number(value) % 1 === 0 || Number(value) === 1) &&
            Number(value) !== 15
          );
        },
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        show: index === 2 ? true : false, // 隐藏 x 轴标签
        interval,
        // formatter: (number: string) => {
        //   console.log("[BOWEN_LOG] 🚀 ~~ getChartsDefaultOptions ~~ number:", number);
        //   return Number(number) % 5 === 0 || Number(number) === 1 ? number : "";
        // },
      },
      axisTick: {
        interval,
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: lineColor,
        },
      },
    },
    yAxis: {
      type: "value",
      max,
      min,
      // max,
      // min,
      // minorTick: {
      //   show: true,
      // },
      minorSplitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      // axisPointer: {
      //   type: "line",
      //   snap: true,
      //   show: true,
      //   label: {
      //     show: false,
      //     // formatter: function (params) {
      //     //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
      //     // },
      //     backgroundColor: "#8e96a1",
      //   },
      // },
    },
    dataZoom: [
      {
        show: true,
        type: "inside",
        filterMode: "none",
      },
    ],
    series: seriesList,
  } as EChartsOption;
};

export const getDefaultSelection = () => ["wireControl"];

